module.exports = __webpack_public_path__ + "static/bg01-90cdb89e33ff79ce7088d31decf69b74.jpg";